import { render, staticRenderFns } from "./Map3D.vue?vue&type=template&id=850936b4&scoped=true&"
import script from "./Map3D.vue?vue&type=script&lang=js&"
export * from "./Map3D.vue?vue&type=script&lang=js&"
import style0 from "./Map3D.vue?vue&type=style&index=0&id=850936b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850936b4",
  null
  
)

export default component.exports